import { DownloadOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import { useAppSelector } from 'app/providers/StoreProvider/config/store';
import React, { FC } from 'react';
import { ORDCard } from 'shared/ui';

import videoSelector, { VideoType } from '../model/selectors';
import VideoModal from './VideoModal/VideoModal';

const sberDesc =
  'Если у вас не воспроизводится, или не скачивается видео и вы являетесь сотрудником Сбера, перейдя по этой ссылке вы получите доступ к видео-материалу';

interface VideoCardProps {
  videoType: VideoType;
}

const VideoCard: FC<VideoCardProps> = (props) => {
  const { videoType } = props;
  const videos = useAppSelector(videoSelector(videoType));
  return (
    <>
      {videos.map((video) => (
        <ORDCard
          key={video.theme}
          withMeta
          hoverable
          cover={<img src={video.imgUrl} alt="..." />}
          metaTitle={video.theme}
          metaDescription={
            <div className="sber-desc">
              <a target="_blank" href={video.sberUrl} rel="noreferrer">
                Ссылка для сотрудников Сбера
              </a>
              <Popover content={sberDesc}>
                <InfoCircleOutlined style={{ marginLeft: '10px' }} />
              </Popover>
            </div>
          }
          actions={[
            <VideoModal
              url={video.url}
              subThemes={video.subThemes}
              ordAttribute={video.ordAttribute}
              youtubeVideo={video.youtubeVideo}
              description={video.description}
              theme={video.urlParam}
            />,
            <a href={video.url} data-ord-attribute="downloadLessonBtn">
              <DownloadOutlined style={{ fontSize: '17rem' }} />
            </a>,
          ]}
        />
      ))}
    </>
  );
};

export default VideoCard;
